console.log('[CUSTOM.JS] Version 1.4 - Enhanced gallery debugging and direct setActiveMedia call');

/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Symmetry is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Symmetry, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Symmetry:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Leverages 'code splitting' for some features.
 *  - Is completely custom built (no JS libraries)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Symmetry broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
*   4.  on:cart:after-merge
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 */

// Re-initialize product-block and media-gallery when loaded dynamically in quickbuy modal
document.addEventListener('on:quickbuy:after-open', function(event) {
  var quickbuyContainer = event.target;
  if (!quickbuyContainer) return;
  
  console.log('[QUICKBUY DEBUG] Quickbuy modal opened', quickbuyContainer);
  
  var innerContainer = quickbuyContainer.querySelector('.inner');
  if (!innerContainer) {
    console.log('[QUICKBUY DEBUG] No .inner container found');
    return;
  }
  
  // Function to initialize components after content is loaded
  var initializeQuickbuyComponents = function() {
    console.log('[QUICKBUY DEBUG] Initializing quickbuy components');
    
    // Find all product-block elements in the quickbuy modal
    var productBlocks = quickbuyContainer.querySelectorAll('product-block');
    console.log('[QUICKBUY DEBUG] Found product-block elements:', productBlocks.length);
    
    productBlocks.forEach(function(block) {
      // Trigger lazy script initialization if available
      if (window.initLazyScript && typeof window.initLazyScript === 'function') {
        window.initLazyScript(block, function() {
          // After lazy script loads, manually call init if it exists
          if (block.init && typeof block.init === 'function') {
            block.init();
          }
        });
      } else if (block.init && typeof block.init === 'function') {
        // Fallback: directly call init if lazy script not needed
        block.init();
      }
    });
    
    // Re-initialize media-gallery to ensure variant changes update carousel
    var mediaGalleries = quickbuyContainer.querySelectorAll('media-gallery');
    console.log('[QUICKBUY DEBUG] Found media-gallery elements:', mediaGalleries.length);
    
    mediaGalleries.forEach(function(gallery, index) {
      console.log('[QUICKBUY DEBUG] Processing gallery #' + index);
      
      // Find the variant picker and set up the connection
      var section = gallery.closest('.js-product');
      console.log('[QUICKBUY DEBUG] Gallery section:', section);
      
      if (section) {
        var variantPicker = section.querySelector('variant-picker');
        console.log('[QUICKBUY DEBUG] Variant picker found:', variantPicker);
        
        console.log('[QUICKBUY DEBUG] Adding variant:change event listener to section');
        
        // Add debug listener for variant:change events and manually trigger gallery update
        section.addEventListener('on:variant:change', function(evt) {
          console.log('[QUICKBUY DEBUG] ===== variant:change event fired! =====');
          console.log('[QUICKBUY DEBUG] Event detail:', evt.detail);
          console.log('[QUICKBUY DEBUG] Featured media ID:', evt.detail.variant?.featured_media?.id);
          console.log('[QUICKBUY DEBUG] Gallery element:', gallery);
          console.log('[QUICKBUY DEBUG] Gallery onVariantChange method exists:', typeof gallery.onVariantChange);
          
          // Manually call onVariantChange since the original listener isn't connected to dynamic content
          if (gallery.onVariantChange && typeof gallery.onVariantChange === 'function') {
            console.log('[QUICKBUY DEBUG] Manually calling gallery.onVariantChange()');
            console.log('[QUICKBUY DEBUG] Gallery properties:', {
              mediaGroupingEnabled: gallery.mediaGroupingEnabled,
              slideshow: gallery.slideshow,
              variantPicker: gallery.variantPicker,
              setActiveMedia: typeof gallery.setActiveMedia
            });
            
            // Call onVariantChange
            gallery.onVariantChange(evt);
            
            // Check if setActiveMedia was called
            if (gallery.setActiveMedia && typeof gallery.setActiveMedia === 'function') {
              console.log('[QUICKBUY DEBUG] setActiveMedia exists, calling it directly as fallback');
              if (evt.detail.variant && evt.detail.variant.featured_media) {
                gallery.setActiveMedia(evt.detail.variant.featured_media.id, true);
              }
            }
          } else {
            console.log('[QUICKBUY DEBUG] ERROR: gallery.onVariantChange is not a function!');
          }
        });
        
        console.log('[QUICKBUY DEBUG] Event listener added successfully');
        
        if (variantPicker && gallery.setFromVariantPicker && typeof gallery.setFromVariantPicker === 'function') {
          // Wait for variant-picker to be loaded
          if (window.theme && window.theme.whenComponentLoaded) {
            window.theme.whenComponentLoaded([variantPicker], function() {
              console.log('[QUICKBUY DEBUG] Variant picker loaded, calling setFromVariantPicker');
              gallery.setFromVariantPicker();
            });
          }
        } else {
          console.log('[QUICKBUY DEBUG] Missing:', {
            variantPicker: !!variantPicker,
            setFromVariantPicker: typeof gallery.setFromVariantPicker,
            whenComponentLoaded: !!(window.theme && window.theme.whenComponentLoaded)
          });
        }
      }
    });
  };
  
  // Check if content is already loaded
  if (innerContainer.children.length > 0) {
    console.log('[QUICKBUY DEBUG] Content already loaded, initializing immediately');
    setTimeout(initializeQuickbuyComponents, 100);
  } else {
    console.log('[QUICKBUY DEBUG] Waiting for content to load...');
    
    // Use MutationObserver to wait for content to be loaded into .inner
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          console.log('[QUICKBUY DEBUG] Content loaded into .inner container');
          observer.disconnect();
          setTimeout(initializeQuickbuyComponents, 100);
          return;
        }
      }
    });
    
    observer.observe(innerContainer, {
      childList: true,
      subtree: false
    });
  }
});

/**
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - selectedOptions: an array of currently selected options (e.g. ['Blue', 'Large'])
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:after-merge
 * -------------------------------------------------------------------------------------------------
 * Fires after a list of cart items has finished being dynamically updated after a cart change.
 *
 * How to listen:
 * document.addEventListener('on:cart:after-merge', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Symmetry utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Symmetry has no third-party JavaScript dependencies.
 *
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */
